module.exports = __webpack_public_path__ + "media/images/banner/tcvb/tcvb-en-4e14159dab138ce194a075f654dedf31.jpg";